"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const shared_1 = require("../shared");
const types_1 = require("../shared/types");
const Context_1 = __importDefault(require("./Context"));
const Node_1 = __importDefault(require("./Node"));
const Logger_1 = __importDefault(require("./Logger"));
const environment_1 = require("./environment");
const getMetadata_1 = __importDefault(require("../shared/helpers/getMetadata"));
const HypertuneEdgeInitDataProvider_1 = __importDefault(require("./initDataProviders/HypertuneEdgeInitDataProvider"));
const VercelEdgeConfigInitDataProvider_1 = __importDefault(require("./initDataProviders/VercelEdgeConfigInitDataProvider"));
const minIntervalMs = 1000;
const defaultIntervalMs = 2000;
/**
 * TODO
 * - Remove `queryCode`; consolidate with `query`; benefit of having them
 * separate was `queryCode` can be codegen'd differently, but this is not
 * necessary
 * - Add default values to arguments where possible
 * - Move all arguments into `CreateOptions` with type parameters if they have
 * generated types, then codegen concrete `CreateSourceOptions`
 */
function create({ NodeConstructor = Node_1.default, token, query = null, queryId, queryCode, variableValues = {}, override = null, options = {}, }) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const traceId = (0, shared_1.uniqueId)();
    let logger;
    const remoteLoggingMode = (_b = (_a = options.remoteLogging) === null || _a === void 0 ? void 0 : _a.mode) !== null && _b !== void 0 ? _b : (environment_1.isBrowser ? "session" : "normal");
    try {
        logger = new Logger_1.default({
            traceId,
            token,
            remoteLoggingMode,
            remoteFlushIntervalMs: ((_c = options.remoteLogging) === null || _c === void 0 ? void 0 : _c.flushIntervalMs) !== undefined
                ? options.remoteLogging.flushIntervalMs === null ||
                    options.remoteLogging.flushIntervalMs === 0 // TODO: Deprecate
                    ? null
                    : clampInterval(options.remoteLogging.flushIntervalMs)
                : defaultIntervalMs,
            remoteLoggingEndpointUrl: (_e = (_d = options.remoteLogging) === null || _d === void 0 ? void 0 : _d.endpointUrl) !== null && _e !== void 0 ? _e : shared_1.prodLogsEndpointUrl,
            localLogger: options.localLogger,
        });
    }
    catch (error) {
        if (options.localLogger) {
            options.localLogger(types_1.LogLevel.Error, "Pre-initialize error.", (0, getMetadata_1.default)(error));
        }
        else {
            // eslint-disable-next-line no-console
            console.error("[Hypertune] Pre-initialize error.", error);
        }
        return new NodeConstructor({
            context: null,
            logger: null,
            parent: null,
            step: null,
            expression: null,
        });
    }
    const usesVercelEdgeConfig = options.initDataProvider &&
        options.initDataProvider instanceof VercelEdgeConfigInitDataProvider_1.default;
    logger.log(types_1.LogLevel.Debug, null, "Detected environment.", {
        isBrowser: environment_1.isBrowser,
        usesVercelEdgeConfig,
    });
    try {
        const context = new Context_1.default({
            traceId,
            query,
            initQuery: queryId
                ? { type: "StoredQuery", id: queryId }
                : queryCode
                    ? { type: "GraphqlQuery", code: queryCode }
                    : { type: "Query", query },
            variableValues,
            initData: (_f = options.initData) !== null && _f !== void 0 ? _f : null,
            lastInitDataRefreshTime: (_h = (_g = options.lastInitDataRefreshTime) !== null && _g !== void 0 ? _g : options.lastDataProviderInitTime) !== null && _h !== void 0 ? _h : null,
            initDataProvider: options.initDataProvider !== undefined
                ? options.initDataProvider
                : new HypertuneEdgeInitDataProvider_1.default({
                    token,
                    baseUrl: shared_1.prodEdgeCdnBaseUrl,
                    branchName: options.branchName,
                    localLogger: options.localLogger,
                }),
            initDataRefreshIntervalMs: 
            // Prioritize the new option else use the old option if it's not set to
            // 0 else use the default interval. In all cases, force the value to be
            // at least the minimum interval.
            clampInterval((_j = options.initDataRefreshIntervalMs) !== null && _j !== void 0 ? _j : (options.initIntervalMs || defaultIntervalMs)),
            shouldRefreshInitData: 
            // Prioritize the new option else if the old option is set to 0,
            // disable, else enable except when using Vercel Edge Config.
            (_l = (_k = options.shouldRefreshInitData) !== null && _k !== void 0 ? _k : options.shouldCheckForUpdates) !== null && _l !== void 0 ? _l : (options.initIntervalMs === 0 ? false : !usesVercelEdgeConfig),
            shouldRefreshInitDataOnCreate: (_m = options.shouldRefreshInitDataOnCreate) !== null && _m !== void 0 ? _m : !usesVercelEdgeConfig,
            logger,
            cacheSize: (_o = options.cacheSize) !== null && _o !== void 0 ? _o : shared_1.defaultCacheSize,
            override: override !== null && override !== void 0 ? override : null,
        });
        return new NodeConstructor({
            context,
            logger,
            parent: null,
            step: null,
            expression: (_q = (_p = context.initData) === null || _p === void 0 ? void 0 : _p.reducedExpression) !== null && _q !== void 0 ? _q : null,
        });
    }
    catch (error) {
        logger.log(types_1.LogLevel.Error, 
        /* commitId */ null, "Initialize error.", (0, getMetadata_1.default)(error));
        return new NodeConstructor({
            context: null,
            logger,
            parent: null,
            step: null,
            expression: null,
        });
    }
}
exports.default = create;
function clampInterval(intervalMs) {
    return Math.max(intervalMs, minIntervalMs);
}
//# sourceMappingURL=create.js.map